import { use } from "react";
import AxiosAPI from "./AxiosAPI";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectToken } from "../redux/slices/userSlice";
import store from "../redux/store";


export const fetchUserDetails = async (uid) => {
    try {
        const response = await AxiosAPI.get(`/user/getuserdetails?uid=${uid}`)
        return response.data
    } catch (error) {
        console.log(error, "while fetching user details")
        throw error.response?.data || error;
    }
}

export const handleEditUser = async (user) => {
    console.log("user",user);
    try {
        const response = await AxiosAPI.put(
            `/user/updateuser/${user.id}`,
            user, {
            headers: {
                "Content-Type": "application/json",
            },
        }
        );
        return response.data
    } catch (error) {
        console.log(error, "while updating user ")
        throw error.response?.data || error;
    }
}

export const handleCreateUserWithEmailAndPassword = async (loginId,password) => {
    try {
        let params={
            loginID:loginId,
            password:password
        }
        const response = await AxiosAPI.post(
            `/user/createuserwithemailandpassword`,
            params, {
            headers: {
                "Content-Type": "application/json",
            },
        }
        );
        return response.data
    } catch (error) {
        console.log(error, "while creating user ")
        throw error.response?.data || error;
    }
}

export const handleChangePassword = async (loginID,password) => {
    const params={
        loginID:loginID, password:password
    }
    try {
        const response = await AxiosAPI.post(
            `/user/updatepassowrd`,
            params, {
            headers: {
                "Content-Type": "application/json",
            },
        }
        );
        return response.data
    } catch (error) {
        console.log(error, "while updating password ")
        throw error.response?.data || error;
    }
}

export const handleResetPassword = async (loginID) => {
  try {
      const params={
        loginID:loginID
    }
    const response = await AxiosAPI.post("/user/forgotpassword", params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
  throw error.response?.data || error;
  }
};
// export const handleResetPassword = async (loginID) => {
//     const params={
//         loginID:loginID
//     }
//     try {
//       const response = await AxiosAPI.post("/user/forgotpassword", params, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//         return response.data
//     } catch (error) {
//         console.log(error, "while reset password ")
//         throw error.response?.data || error;
//     }
// }
export const handleCreateUser = async (user) => {
    try {
        const response = await AxiosAPI.post(
            `/user/createuser`,
            user, {
            headers: {
                "Content-Type": "application/json",
            },
        }
        );
        return response.data
    } catch (error) {
        console.log(error, "while creating user ")
        throw error.response?.data || error;
    }
}


export const fetchAcl = async (storeid) => {
  const token = selectToken(store.getState());
    try {
        const response = await axios.get(`https://backend-o3dyulj4pa-el.a.run.app/v2/user/access?storeid=${storeid}`,
                 {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
        )
        return response.data
    } catch (error) {
        console.error("error",error);
        throw error.response?.data || error;
    }
}


